<template>
  <div class="animated fadeIn">
    <default-heading text="Time Series Report" class="mt-3">
      <template #right>
        <b-button v-if="report_data" variant="success" class="ml-1" @click="download">
          <i class="fal fa-download" />
        </b-button>
      </template>
    </default-heading>

    <div>
      <div v-if="report_data && report_data.data" ref="report" class="p-3">
        <TimeSeriesReport :report="report_data.data" :chart_type="chart_type" />
      </div>

      <TimeSeriesReportForm
        v-else
        @submit="submit"
        @setChartType="(chartType) => {
          chart_type = chartType
        }"
      />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import TimeSeriesReportForm from '@/components/modus/result/TimeSeriesReportForm.vue';
import SampleResultModel from '@/models/result/SampleResultModel';
import TimeSeriesReport from '../../components/modus/result/TimeSeriesReport.vue';
import { downloadHtmlCanvas } from '../../shared/utils';

export default {
  name: 'TimeSeriesReport',
  components: {
    DefaultHeading,
    TimeSeriesReportForm,
    TimeSeriesReport
  },
  data () {
    return {
      customer_id: this.$store.getters.getAuthCustomerID,
      report_data: null,
      chart_type: 'bar'
    }
  },
  methods: {
    async submit (form_data) {
      try {
        const model = new SampleResultModel()
        const { response } = await model.getTimeSeries({
          ...form_data,
          customer_id: this.customer_id
        })

        if (response && response.status === 200 && response.data) {
          this.report_data = response.data
        }
      } catch (error) {
        console.error(error)
      }
    },

    download() {
      const { report } = this.$refs;
      const fileName = `time-series-report.pdf`;
      downloadHtmlCanvas(report, fileName);
    }
  }
}
</script>
